<template>
    <div class="block43">
        <!-- 返回 -->
        <div class="return">
            <router-link to="/"><span class="arrow"></span>返回首页</router-link>
        </div>
        <!-- 返回 -->
        <!-- 内容 -->
        <div class="container">
          <h2 class="title1">废气排放标准</h2>
          <div class="container-content">
            <p class="text_line">废气排放标准</p>
            <p>本摩托车符合废气的排放标准-国四</p>
            <p class="text_line">OBD诊断接口</p>
            <p>OBD诊断接口在鞍座下（红色）</p>
            <img src='./img/img1.jpg' width="100%">
          </div>
          <div class="foot-btn">
            <div class="prev">
              <router-link to="/block42">上一页</router-link>
            </div>
            <div class="next">
              <router-link to="/block44">下一页</router-link>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
export default {
  props: ["id"],
  watch: {'$route'(to, from) {if(this.id != null) {setlink(this.id);}}},
  mounted() {
    setlink(this);

  },
  methods: {
    goto(path) {this.$router.push({ path: path });}
  }
};
</script>